import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Paper, Grid, Typography, Divider, Link } from '@mui/material';
import { ListItem, ListItemSecondaryAction, ListItemText, List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';

import {
    oneAssetEventListSelector, eventDetailViewSelector,
    eventContentSelector, getEventAddress,
    setEventDetailView, setViewType, removeEventDetailView
} from '../../features/events/eventsSlice';
import { setCenter, setMapControl } from '../../features/map/mapSlice';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import eventIcons from '../../utils/eventIcons.js';

const useStyles = makeStyles((theme) => ({
    active: {
        backgroundColor: 'Beige'
    },
    inactive: {
        backgroundColor: 'White'
    },
    small: {
        width: useTheme().spacing(3),
        height: useTheme().spacing(3),
    },

}));

const AssetEventListView = ({ assetId }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const eventDetailView = useSelector(eventDetailViewSelector);
    const oneAssetEventList = useSelector(oneAssetEventListSelector);
    const eventContent = useSelector(eventContentSelector);
    const assetNames = useSelector(assetNamesSelector);
    const regn = assetNames && assetNames[`${assetId}`] && assetNames[`${assetId}`].regn;

    const toggleEventDetails = (eventData) => {
        if (eventData.event_id !== eventDetailView) {
            if (regn) {
                dispatch(getEventAddress({
                    searchParam: {
                        eventId: eventData.event_id,
                        lat: eventData.lat,
                        lng: eventData.lng,
                        regn: regn,
                    }
                }));
                dispatch(setEventDetailView(eventData.event_id));
                dispatch(setCenter({
                    lat: parseFloat(eventData.lat),
                    lng: parseFloat(eventData.lng),
                }))
                dispatch(setMapControl('event'));
            }
        } else {
            dispatch(setMapControl('asset'));
        }
    }

    const closeView = () => {
        dispatch(removeEventDetailView());
        dispatch(setViewType('default'));
        dispatch(setMapControl('asset'));
    }

    const tickbuild = () => {
        let eventlist = [];
        if (oneAssetEventList) {
            oneAssetEventList.forEach((eventId, index) => {
                const eventData = eventContent[`${eventId}`];
                let timedisplay;
                if (moment(eventData.event_time).format("D/M/Y") === moment().format("D/M/Y")) {
                    timedisplay = `Today ${moment(eventData.event_time).format("h:mm:ss A")}`;
                } else {
                    timedisplay = `${moment(eventData.event_time).format("D/M/Y h:mm:ss A")}`;
                }
                eventlist.push(
                    <Fragment key={index}>
                        <ListItem
                            className={eventId === eventDetailView ? classes.active : classes.inactive}
                        >
                            <ListItemText
                                primary={
                                    <Link href="#" onClick={() => toggleEventDetails(eventData)}>
                                        <Typography
                                            variant="body1"
                                            color='textPrimary'
                                        >
                                            <span>
                                                <b>
                                                    {eventData.event_desc}
                                                </b>
                                            </span>
                                        </Typography>
                                    </Link>
                                }
                                secondary={
                                    <Typography
                                        variant="body2"
                                        color='textPrimary'
                                    >
                                        {timedisplay}
                                    </Typography>
                                }
                            />
                            <ListItemSecondaryAction onClick={() => toggleEventDetails(eventData)}>
                                {eventIcons(eventData.event_desc, 0.7)}
                            </ListItemSecondaryAction>
                        </ListItem>
                        {
                            index < oneAssetEventList.length - 1 && <Divider />
                        }
                    </Fragment>

                );
            });
        }
        return eventlist;
    }

    if (regn) {
        return (
            <Paper elevation={3} style={{ backgroundColor: 'Ivory' }}>
                <div style={{ margin: '5px' }}>
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid item sm={12}>
                            <List dense>
                                <ListItem style={{ backgroundColor: 'Ivory' }}>
                                    <ListItemText
                                        primary={<Typography variant="h6">Recent Events</Typography>}
                                        secondary={<Typography variant="subtitle1"><b style={{ color: 'dodgerblue' }}>{regn}</b></Typography>}
                                    />
                                    <ListItemSecondaryAction>
                                        <CancelIcon onClick={closeView} color="secondary" />
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                                {
                                    tickbuild()
                                }
                            </List>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        );
    } else {
        return null;
    }

}

export default React.memo(AssetEventListView);

/**<Button
                                        startIcon={<CancelIcon />}
                                        variant="contained"
                                        color="secondary"
                                        onClick={closeView}
                                        size="small"
                                    />
 *
 */